import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { styled } from "styled-components";
import BtnElement from "../elements/BtnElement";
import { AppColors } from "../styles/colors";

interface AgreementButtonProps {
  children: React.ReactNode;
  isClicked?: boolean;
  onClicked?: () => void;
  fullWidth?: boolean;
}

const ButtonAgreement = styled(BtnElement)<{ $isClicked: boolean }>`
  display: flex;
  gap: 6px;
  width: fit-content;
  padding: 0.25rem;
  color: ${({ $isClicked }) =>
    $isClicked ? `${AppColors.onInput2}` : `${AppColors.onInput1}`};
  font-size: 15px;
  font-weight: 500;
  text-align: start;

`;

export default function AgreementButton({
  children,
  isClicked = false,
  onClicked,
  fullWidth = false,
}: AgreementButtonProps) {
  return (
    <ButtonAgreement
      $isClicked={isClicked}
      $variant="text"
      $size="small"
      $fullWidth={fullWidth}
      onClick={onClicked}
    >
      <CheckCircleIcon fontSize="small"></CheckCircleIcon>
      {children}
    </ButtonAgreement>
  );
}
